import request from './request'

/**
 * 获取指定功能类型的启用颜色主题及区间配色
 * @param {number} type - 1=采光分析 2=视野范围 3=噪音分析
 * @returns {Promise<string[]>} 按 thresholdIndex 排序的颜色数组，如 ['#feefe7', ...]
 *                              若无启用主题则返回空数组，调用方降级到默认颜色
 */
export function getCustomColors (type) {
  return request({
    url: '/api/colorTheme/default',
    method: 'get',
    params: { type }
  }).then(res => {
    if (res.data && res.data.result && res.data.result.items) {
      const items = res.data.result.items
      return items
        .sort((a, b) => a.thresholdIndex - b.thresholdIndex)
        .map(item => item.color)
    }
    return []
  }).catch(() => [])
}
